import React from "react";
import { BackgroundImage } from "@montana/shared/background-image";
import { Link } from "@montana/shared/link";
import { IProductEntranceContainerBlock, IProductEntranceBlock } from "@montana/models/generated/cms.interface";
import { Appear } from "@montana/shared/appear";
import { SoftHyphens } from "@montana/shared/soft-hyphens";

export const M00ProductEntrancesBlock: React.FC<IProductEntranceContainerBlock> = React.memo((props: IProductEntranceContainerBlock): JSX.Element | null => {
    const {
        productEntrances,
    } = props;

    return (
        <div className="product-entrances row">
            {productEntrances ?
                productEntrances.map(({ header, text, image, link }: IProductEntranceBlock, index) => (
                    <div key={index} className="product-entrances__col col col--equal col--no-padding">
                        <div className="product-entrances__entrance">
                            <div className="product-entrances__entrance-content">
                                <Appear>
                                    <SoftHyphens tagName="h2" className="product-entrances__header display-1" text={header}/>
                                </Appear>
                                <Appear delay={100}>
                                    <SoftHyphens tagName="p" className="product-entrances__manchet" text={text}/>
                                </Appear>
                            </div>
                            {(link && link.url) && <Link className="product-entrances__link" to={link.url} target={link.target} title={link.title} />}
                            <BackgroundImage imageReference={image} appearAnimation />
                        </div>
                    </div>
                )) : null}
        </div>
    );
});
